import React, { useRef } from 'react';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Button } from './Button';
import { FracturedHalo } from './FracturedHalo';
import { ParticleBackground } from './ParticleBackground';
export const Hero: React.FC = () => {
  const sectionRef = useRef<HTMLDivElement>(null);
  const {
    scrollYProgress
  } = useScroll({
    target: sectionRef,
    offset: ['start start', 'end start']
  });
  const y = useTransform(scrollYProgress, [0, 1], ['0%', '40%']);
  const opacity = useTransform(scrollYProgress, [0, 0.8], [1, 0]);
  const scale = useTransform(scrollYProgress, [0, 0.5], [1, 0.8]);
  return <motion.section ref={sectionRef} className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden nebula-bg" initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    duration: 1
  }} style={{
    opacity
  }} data-id="element-109">
      <div className="absolute bottom-0 left-0 right-0 h-48 overflow-hidden" data-id="element-110">
        <ParticleBackground className="opacity-15" data-id="element-111" />
      </div>
      <motion.div className="container mx-auto px-4 z-10 text-center" style={{
      y,
      scale
    }} data-id="element-112">
        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="mb-12" data-id="element-113">
          <div className="relative inline-block" data-id="element-114">
            <div className="absolute inset-0 flex items-center justify-center" data-id="element-115">
              <motion.div className="absolute" animate={{
              scale: [1, 1.05, 1],
              opacity: [0.3, 0.5, 0.3]
            }} transition={{
              duration: 4,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-116">
                <FracturedHalo size={800} segments={16} opacity={0.4} animate={true} vortexAnimation={false} data-id="element-117" />
              </motion.div>
              <motion.div className="absolute" initial={{
              opacity: 0
            }} animate={{
              opacity: 1
            }} transition={{
              duration: 1.5,
              delay: 0.5
            }} data-id="element-118">
                <FracturedHalo size={650} segments={12} opacity={0.8} animate={true} vortexAnimation={true} data-id="element-119" />
              </motion.div>
              <motion.div className="absolute" animate={{
              rotate: 360,
              scale: [1, 1.02, 1]
            }} transition={{
              rotate: {
                duration: 20,
                repeat: Infinity,
                ease: 'linear'
              },
              scale: {
                duration: 3,
                repeat: Infinity,
                ease: 'easeInOut'
              }
            }} data-id="element-120">
                <FracturedHalo size={500} segments={8} opacity={0.6} animate={true} vortexAnimation={false} data-id="element-121" />
              </motion.div>
              <motion.div className="absolute w-[700px] h-[700px] rounded-full" style={{
              background: 'radial-gradient(circle, rgba(234, 246, 255, 0.1) 0%, transparent 70%)'
            }} animate={{
              scale: [1, 1.1, 1],
              opacity: [0.2, 0.4, 0.2]
            }} transition={{
              duration: 5,
              repeat: Infinity,
              ease: 'easeInOut'
            }} data-id="element-122" />
            </div>
            <div className="relative flex flex-col items-center space-y-6" data-id="element-123">
              <motion.h1 className="text-neon-blue font-block text-6xl md:text-8xl lg:text-9xl font-bold tracking-[0.3em] uppercase relative" initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              duration: 1,
              delay: 0.5
            }} style={{
              letterSpacing: '0.3em',
              fontWeight: 900,
              textShadow: '0 0 20px rgba(234, 246, 255, 0.6), 0 0 40px rgba(234, 246, 255, 0.4), 0 0 60px rgba(234, 246, 255, 0.2)'
            }} data-id="element-124">
                <motion.span className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent" animate={{
                x: ['-200%', '200%']
              }} transition={{
                duration: 3,
                repeat: Infinity,
                repeatDelay: 5,
                ease: 'easeInOut'
              }} style={{
                WebkitMaskImage: 'linear-gradient(to right, transparent, black, transparent)',
                maskImage: 'linear-gradient(to right, transparent, black, transparent)'
              }} data-id="element-125" />
                DEPLOID
              </motion.h1>
            </div>
          </div>
        </motion.div>
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.8
      }} data-id="element-126">
          <motion.p className="text-2xl md:text-3xl lg:text-4xl font-light tracking-wide mb-16 text-neon-blue/90 max-w-3xl mx-auto" initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          duration: 1,
          delay: 1
        }} data-id="element-127">
            Deploy the Future. Today.
          </motion.p>
          <motion.div className="flex flex-col sm:flex-row justify-center items-center gap-6" initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.8,
          delay: 1.2
        }} data-id="element-128">
            <Button primary data-id="element-129">Contact Us</Button>
            <Button data-id="element-130">Learn More</Button>
          </motion.div>
        </motion.div>
      </motion.div>
    </motion.section>;
};